import { ReactElement } from 'react';
import { Box } from '@mui/material';

import { KnownDialogs, useDialog } from 'modules/dialogs';
import { Dialog } from 'modules/dialogs/components/Dialog';

interface ISuccessDialogProps {
  type: KnownDialogs;
  children?: ReactElement;
}

export function SuccessDialog({
  type,
  children,
}: ISuccessDialogProps): ReactElement {
  const { isOpened, onClose } = useDialog(type);

  return (
    <Dialog open={isOpened} onClose={onClose}>
      <Box
        sx={theme => ({
          display: 'flex',
          flexDirection: 'column',
          minHeight: 487,

          [theme.breakpoints.down('md')]: { minHeight: 475 },
        })}
      >
        {children}
      </Box>
    </Dialog>
  );
}
